import type { FC, PropsWithChildren } from 'react'

import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import PropCardBase, * as PropCard from '@segment/matcha/recipes/PropCard'

import PropCardCtaImage from './PropCardCtaImage'

const copy = {
  heading: `Why Every Fintech Business Needs a CDP`,
  paragraph: `In this guide we discuss why a customer data platform may be the key ingredient for financial services & technology companies.`,
}

const button = {
  text: `Access the guide`,
  url: `https://learn.segment.com/why-fintech-needs-a-cdp/`,
}

const PropCardCta: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBase variant="noCopy">
        <Section.Contents>
          <StyledColumnTrack columns={1} center={true}>
            <StyledPropCardBase>
              <PropCard.Copy>
                <PropCard.Title>{copy.heading}</PropCard.Title>
                <PropCard.Text>{copy.paragraph}</PropCard.Text>
                <Button href={button.url} tag="a" size="large" color="primary" variant="filled">
                  {button.text}
                </Button>
              </PropCard.Copy>
              <PropCard.Img>
                <PropCardCtaImage />
              </PropCard.Img>
            </StyledPropCardBase>
          </StyledColumnTrack>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledPropCardBase = styled(PropCardBase)`
  ${({ theme }) => theme.breakpoints.down(`xs`)} {
    grid-template-areas:
      'img '
      'copy';
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 720px;
  margin: 0 auto;
  row-reverse: reverse;
`

export default PropCardCta
